var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit, Prop } from "vue-property-decorator";
import { CaseApplyRecordService } from '~/services/domain-service/case-apply-record.service.ts';
var RobberyComponents = /** @class */ (function (_super) {
    __extends(RobberyComponents, _super);
    function RobberyComponents() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //委托方数据实体
        _this.modifyModel = {
            applyDescription: "",
            applyCategory: "GRAB_CACE",
            caseIds: _this.caseIds,
            confirm: 0
        };
        //数据校验
        _this.rules = {
            applyDescription: [{ required: true, message: "请输入申请说明", trigger: "blur" }],
        };
        return _this;
    }
    RobberyComponents.prototype.refreshList = function () { };
    RobberyComponents.prototype.close = function () {
        this.reset();
    };
    //重置方法
    RobberyComponents.prototype.reset = function () {
        var modifyForm = this.$refs["modify-form"];
        modifyForm.resetFields();
    };
    /**
     * 首次打开调用
     */
    RobberyComponents.prototype.update = function () {
    };
    /**
     * 提交验证并并与数据库交互
     */
    RobberyComponents.prototype.commit = function () {
        var _this = this;
        var modifyForm = this.$refs["modify-form"];
        modifyForm.validate(function (valid) {
            if (!valid)
                return false;
            _this.caseApplyRecordService.applyRobCase(_this.modifyModel)
                .subscribe(function (data) {
                _this.$message.success('抢案申请成功');
                _this.close();
            });
        });
    };
    __decorate([
        Prop()
    ], RobberyComponents.prototype, "caseIds", void 0);
    __decorate([
        Dependencies(CaseApplyRecordService)
    ], RobberyComponents.prototype, "caseApplyRecordService", void 0);
    __decorate([
        Emit("refreshList")
    ], RobberyComponents.prototype, "refreshList", null);
    __decorate([
        Emit("close")
    ], RobberyComponents.prototype, "close", null);
    RobberyComponents = __decorate([
        Component({
            components: {}
        })
    ], RobberyComponents);
    return RobberyComponents;
}(Vue));
export default RobberyComponents;
